export default __webpack_public_path__ + "65c1f9338e0849371991844213c21873.jpg";